import React from 'react';

interface LogoProps {
  className?: string;
  height?: number;
}

// Variant 1: Shield with checkmark (Original)
export const GuardLLMLogoShield: React.FC<LogoProps> = ({ className = '', height = 28 }) => {
  return (
    <svg
      viewBox="0 0 200 28"
      className={`transition-all duration-300 group-hover:opacity-80 ${className}`}
      style={{ height: `${height}px` }}
      fill="none"
    >
      <text
        x="0"
        y="22"
        fill="#6366f1"
        style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontSize: '22px',
          fontWeight: 600,
          letterSpacing: '0.05em'
        }}
      >
        GUARD
      </text>
      <path
        d="M72 6L76 4L80 6V12C80 16 78 18 76 20C74 18 72 16 72 12V6Z"
        stroke="#6366f1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M76 10L77.5 11.5L79 9"
        stroke="#6366f1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <text
        x="86"
        y="22"
        fill="currentColor"
        style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontSize: '22px',
          fontWeight: 600,
          letterSpacing: '0.05em'
        }}
      >
        LLM
      </text>
    </svg>
  );
};

// Variant 2: Lock icon
export const GuardLLMLogoLock: React.FC<LogoProps> = ({ className = '', height = 28 }) => {
  return (
    <svg
      viewBox="0 0 200 28"
      className={`transition-all duration-300 group-hover:opacity-80 ${className}`}
      style={{ height: `${height}px` }}
      fill="none"
    >
      <text
        x="0"
        y="22"
        fill="#6366f1"
        style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontSize: '22px',
          fontWeight: 600,
          letterSpacing: '0.05em'
        }}
      >
        GUARD
      </text>
      <rect
        x="72"
        y="12"
        width="8"
        height="8"
        rx="1"
        stroke="#6366f1"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M73 12V9C73 7.5 74 6 76 6C78 6 79 7.5 79 9V12"
        stroke="#6366f1"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="76" cy="16" r="1" fill="#6366f1" />
      <text
        x="86"
        y="22"
        fill="currentColor"
        style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontSize: '22px',
          fontWeight: 600,
          letterSpacing: '0.05em'
        }}
      >
        LLM
      </text>
    </svg>
  );
};

// Variant 3: Brain/AI icon
export const GuardLLMLogoBrain: React.FC<LogoProps> = ({ className = '', height = 28 }) => {
  return (
    <svg
      viewBox="0 0 200 28"
      className={`transition-all duration-300 group-hover:opacity-80 ${className}`}
      style={{ height: `${height}px` }}
      fill="none"
    >
      <text
        x="0"
        y="22"
        fill="#6366f1"
        style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontSize: '22px',
          fontWeight: 600,
          letterSpacing: '0.05em'
        }}
      >
        GUARD
      </text>
      <circle cx="76" cy="12" r="6" stroke="#6366f1" strokeWidth="2" fill="none" />
      <path d="M73 12H79M76 9V15" stroke="#6366f1" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M74 10L78 14M78 10L74 14" stroke="#6366f1" strokeWidth="1" strokeLinecap="round" />
      <text
        x="86"
        y="22"
        fill="currentColor"
        style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontSize: '22px',
          fontWeight: 600,
          letterSpacing: '0.05em'
        }}
      >
        LLM
      </text>
    </svg>
  );
};

// Variant 4: Firewall icon
export const GuardLLMLogoFirewall: React.FC<LogoProps> = ({ className = '', height = 28 }) => {
  return (
    <svg
      viewBox="0 0 200 28"
      className={`transition-all duration-300 group-hover:opacity-80 ${className}`}
      style={{ height: `${height}px` }}
      fill="none"
    >
      <text
        x="0"
        y="22"
        fill="#6366f1"
        style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontSize: '22px',
          fontWeight: 600,
          letterSpacing: '0.05em'
        }}
      >
        GUARD
      </text>
      <path d="M72 6V20M75 6V20M78 6V20" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" />
      <path d="M70 10H80M70 14H80" stroke="#6366f1" strokeWidth="1.5" strokeLinecap="round" />
      <text
        x="86"
        y="22"
        fill="currentColor"
        style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontSize: '22px',
          fontWeight: 600,
          letterSpacing: '0.05em'
        }}
      >
        LLM
      </text>
    </svg>
  );
};

// Variant 5: Minimal dot separator
export const GuardLLMLogoMinimal: React.FC<LogoProps> = ({ className = '', height = 28 }) => {
  return (
    <svg
      viewBox="0 0 200 28"
      className={`transition-all duration-300 group-hover:opacity-80 ${className}`}
      style={{ height: `${height}px` }}
      fill="none"
    >
      <text
        x="0"
        y="22"
        fill="#6366f1"
        style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontSize: '22px',
          fontWeight: 600,
          letterSpacing: '0.05em'
        }}
      >
        GUARD
      </text>
      <circle cx="76" cy="18" r="2.5" fill="#6366f1" />
      <text
        x="86"
        y="22"
        fill="currentColor"
        style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          fontSize: '22px',
          fontWeight: 600,
          letterSpacing: '0.05em'
        }}
      >
        LLM
      </text>
    </svg>
  );
};

// Default export - Shield variant
export default GuardLLMLogoShield;
